import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Button,
  Input,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import emailjs from '@emailjs/browser';
import { addDoc, collection } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/I-CONTA.png";
import { db } from "../../firebase";
export default function ClientPage({ user }) {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [tab, setTab] = useState("documents");
  const navigate = useNavigate();
  const form = useRef()
  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, []);
  const submitForm = async (e) => {
    e.preventDefault();
    try {
      let s = await addDoc(collection(db, "feedback"), {
        name: name,
        message: message,
      });
      if (s) {
        emailjs.sendForm('service_qhjw83l', 'template_mjcros4', form.current, 'FE4Nm6vu9GwxzT44K')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        alert("Form Submitted Successfully");
        setName("")
        setMessage("")
      }
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
      <div className="iconta__admin-navbar">
        <div className="iconta__admin-navbar_logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="iconta__admin-navbar_container">
          <h1>Administrator</h1>
        </div>

        <div />
      </div>

      <div className="admin_back">
        <div className="admin_box">
          <div style={{ display: "flex" }}>
            <h3
              onClick={() => setTab("documents")}
              style={{ cursor: "pointer", margin: "10px" }}
            >
              Documents
            </h3>
            <h3
              onClick={() => setTab("feedback")}
              style={{ cursor: "pointer", margin: "10px" }}
            >
              Feedback Form
            </h3>
            <hr />
          </div>
          {tab === "documents" ? (
            <TableContainer>
              <Table variant="simple">
                <TableCaption>
                  Documents Uploaded to User {user?.email}{" "}
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>Title</Th>
                    <Th>Open</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {user &&
                    user.documents.length > 0 &&
                    user.documents.map((e) => (
                      <Tr>
                        <Td>{e.title}</Td>
                        <Td
                          onClick={() => window.open(e.link, "_blank").focus()}
                        >
                          Click here to view
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <form ref={form} onSubmit={submitForm} className="client">
              <Text mb="8px">Nume: </Text>
              <Input
                value={name}
                name="name"
                onChange={(e)=>setName(e.target.value)}
                placeholder="Name"
                size="sm"
              />
              <Text mb="8px">Message: </Text>
              <Textarea
                value={message}
                name="message"
                onChange={(e)=>setMessage(e.target.value)}
                placeholder="Please enter your message"
                size="sm"
              />

              <Button
                rightIcon={<ArrowForwardIcon />}
                colorScheme="teal"
                variant="outline"
                style={{ margin: "13px" }}
                type="submit"
              >
                Trimite
              </Button>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
